import axios from "../../../util/axios";

const PREFIX_URI = "/basedata/sys/staffEmployee";

export default {
    /** 分页查询本平台职员档案 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data: data}),
    /** 保存职员档案（纳入平台） */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data: data}),
    /** 批量添加职员档案（直接开通登录权限，不设置角色） */
    saveBatch: (employeeIds) => axios.post({url: `${PREFIX_URI}/saveBatch`, data: {employeeIds}}),
    /** 从平台移除职员档案 */
    delete: (id) => axios.get({url: `${PREFIX_URI}/delete`, data: {id: id}}),
};
